import { type CSSObject, MantineProvider } from "@mantine/core";
import React, { type ReactNode } from "react";
import { useTheme } from "src/hooks";

import getBrowserName from "../../../utils/getBrowserName";

interface ThemeWrapperProps {
  children: ReactNode;
}

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
  const theme = useTheme();
  const getStyles = (theme: any) => {
    const styles: CSSObject = {
      "::-webkit-scrollbar": {
        WebkitAppearance: "none",
        height: "9px",
        width: "7px",
        backgroundColor: "transparent",
      },

      "::-webkit-scrollbar-thumb": {
        borderRadius: "4px",
        backgroundColor: theme.colors.main[7],
        boxShadow: "0 0 1px rgba(255, 255, 255, 0.5)",
      },
      // Firefox-specific scrollbar

      "::-moz-scrollbar-thumb": {
        borderRadius: "4px",
        backgroundColor: theme.colors.main[7],
        boxShadow: "0 0 1px rgba(255, 255, 255, 0.5)",
      },
      "::-moz-scrollbar": {
        backgroundColor: "transparent", // Background color for the scrollbar track
        width: "7px", // Set scrollbar width (for older Firefox versions with `::-moz-scrollbar`)
      },
    };

    const browserName = getBrowserName();
    if (browserName === "Firefox") {
      styles["html, body"] = {
        scrollbarColor: `${theme.colors.main[7]} transparent`, // Thumb and track colors
      };
    }
    return styles;
  };
  return (
    <MantineProvider
      theme={{
        ...theme,
        globalStyles: getStyles,
        components: {
          Text: {
            styles: (theme, params, context) => {
              return {
                root: {
                  color: params.color
                    ? params.color
                    : theme.colorScheme === "dark"
                      ? theme.colors.main[6]
                      : theme.colors.main[9],
                },
              };
            },
          },
          Modal: {
            defaultProps: {
              withinPortal: true, // Ensure modals use portals
              keepMounted: false, // Unmount modal content when closed
            },
          },
          Portal: {
            defaultProps: {
              target: "#modals-root", // Centralize all portals to this target
            },
          },
        },
      }}
      withNormalizeCSS
      withGlobalStyles>
      {children}
    </MantineProvider>
  );
};

export default ThemeWrapper;
